import { css, StyleObjectOrFn } from "@chakra-ui/react"
import BeatTheme from "../theme/index"

// eslint-disable-next-line max-len
export const themeStyle = (styles: StyleObjectOrFn) => (props: { theme: typeof BeatTheme }) => css(styles)(props.theme)
